import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Phone, Menu, X } from "lucide-react";
import { useScrollDirection } from '../hooks/useScrollDirection';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollDirection = useScrollDirection();

  const getNavLinkClass = ({ isActive }) => {
    const common = "block py-2 px-4 font-medium transition-colors duration-200 rounded-lg";
    if (isActive) {
      return `${common} text-red-700 bg-red-100`;
    }
    return `${common} text-gray-700 hover:text-red-700 hover:bg-gray-100`;
  };

  return (
    <nav className={`bg-white/90 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-gray-100 transition-transform duration-300 ${scrollDirection === "down" ? "-translate-y-full" : "translate-y-0"}`}>
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">

          {/* Logo */}
          <NavLink to="/" className="flex items-center gap-2 text-xl md:text-2xl font-bold text-gray-900 no-underline group">
            <span className="bg-red-600 text-white p-1 rounded group-hover:bg-red-700 transition-colors">C4S</span>
            <span>Cars4Sell</span>
          </NavLink>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-2">
            <NavLink to="/" className={getNavLinkClass} end>
              Strona główna
            </NavLink>
            <NavLink to="/ogloszenia" className={getNavLinkClass}>
              Ogłoszenia
            </NavLink>
            <NavLink to="/sprzedane" className={getNavLinkClass}>
              Sprzedane
            </NavLink>
            <NavLink to="/o-nas" className={getNavLinkClass}>
              O nas
            </NavLink>
            <a href="https://parts4sell.pl" className={getNavLinkClass({isActive: false})}>
              Części samochodowe
            </a>

            {/* Ikona telefonu + numer */}
            <a
              href="tel:+48538194234"
              className="flex items-center gap-2 ml-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-2 px-4 rounded-full transition-all shadow-sm hover:shadow"
            >
              <Phone size={18} />
              +48 538 194 234
            </a>

            <a
              href="/#contact-form-container"
              className="ml-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-5 rounded-full transition-all shadow-md hover:shadow-lg no-underline"
            >
              Kontakt
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none p-2" aria-label="Otwórz menu">
              {isOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 py-4 px-4 shadow-lg">
          <div className="flex flex-col space-y-2">

            <NavLink to="/" className={getNavLinkClass} onClick={() => setIsOpen(false)} end>
              Strona główna
            </NavLink>
            <NavLink to="/ogloszenia" className={getNavLinkClass} onClick={() => setIsOpen(false)}>
              Ogłoszenia
            </NavLink>
            <NavLink to="/sprzedane" className={getNavLinkClass} onClick={() => setIsOpen(false)}>
              Sprzedane
            </NavLink>
            <NavLink to="/o-nas" className={getNavLinkClass} onClick={() => setIsOpen(false)}>
              O nas
            </NavLink>
            <a href="https://parts4sell.pl" className={getNavLinkClass({isActive: false})} onClick={() => setIsOpen(false)}>
              Części samochodowe
            </a>

            {/* Telefon w mobilnym */}
            <a
              href="tel:+48538194234"
              className="flex items-center justify-center gap-2 bg-gray-100 text-gray-900 font-semibold py-3 rounded-lg"
              onClick={() => setIsOpen(false)}
            >
              <Phone size={20} />
              Zadzwoń: +48 538 194 234
            </a>

            <a
              href="/#contact-form-container"
              className="block text-center bg-red-600 text-white font-bold py-3 rounded-lg mt-4"
              onClick={() => setIsOpen(false)}
            >
              Kontakt
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
